import { CheckCircle2, Phone, ClipboardList, MessageCircle, FileSignature, Laptop } from "lucide-react";

export default function HowToBecomeVikar() {
  const steps = [
    {
      number: 1,
      title: "Udfyld formular",
      description: "Udfyld vores hurtige ansøgningsformular med dine grundlæggende oplysninger",
      icon: ClipboardList,
    },
    {
      number: 2,
      title: "Vi ringer dig op",
      description: "Vi kontakter dig inden for 24 timer for en kort samtale",
      icon: Phone,
    },
    {
      number: 3,
      title: "Kompetenceskema",
      description: "Udfyld dit kompetenceskema så vi kan matche dig optimalt",
      icon: CheckCircle2,
    },
    {
      number: 4,
      title: "Jobsamtale",
      description: "En uformel samtale hvor vi lærer hinanden bedre at kende",
      icon: MessageCircle,
    },
    {
      number: 5,
      title: "Kontrakt underskrives",
      description: "Vi underskriver kontrakten og gør dig klar til første vagt",
      icon: FileSignature,
    },
    {
      number: 6,
      title: "Onboarding",
      description: "Introduktion til vores system og første vagt booket",
      icon: Laptop,
    },
  ];

  return (
    <section className="section py-10 sm:py-14 md:py-18 bg-slate-50">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12">
          <span className="kicker">Processen</span>
          <h2 className="section-title mt-2">
            Sådan bliver du vikar
          </h2>
          <p className="section-subtitle mx-auto">
            Fra ansøgning til din første vagt – processen er hurtig og uformel
          </p>
        </div>

        {/* Desktop: Horizontal flow */}
        <div className="hidden lg:block">
          <div className="relative">
            {/* Connection line */}
            <div className="absolute top-8 left-0 right-0 h-0.5 bg-gradient-to-r from-brand-200 via-brand-400 to-brand-600"
                 style={{ zIndex: 0 }}></div>

            {/* Steps */}
            <div className="relative grid grid-cols-6 gap-4" style={{ zIndex: 1 }}>
              {steps.map((step, index) => {
                const Icon = step.icon;
                return (
                  <div key={index} className="flex flex-col items-center">
                    {/* Icon circle with step number */}
                    <div className="relative w-16 h-16 rounded-full bg-white border-2 border-brand-500 flex items-center justify-center mb-4 shadow-card">
                      <Icon className="text-brand-600" size={24} strokeWidth={2} />
                      <span className="absolute -top-1 -right-1 w-6 h-6 rounded-full bg-brand-500 text-white text-xs font-bold flex items-center justify-center">
                        {step.number}
                      </span>
                    </div>

                    {/* Content */}
                    <h3 className="font-bold text-sm text-slate-900 text-center mb-1">
                      {step.title}
                    </h3>
                    <p className="text-xs text-slate-500 text-center leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Mobile/Tablet: Vertical flow */}
        <div className="lg:hidden space-y-4">
          {steps.map((step, index) => {
            const Icon = step.icon;
            const isLast = index === steps.length - 1;

            return (
              <div key={index} className="relative">
                <div className="flex gap-4">
                  {/* Left: Icon + connector */}
                  <div className="flex flex-col items-center flex-shrink-0">
                    {/* Icon circle with step number */}
                    <div className="relative w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-white border-2 border-brand-500 flex items-center justify-center shadow-card">
                      <Icon className="text-brand-600" size={22} strokeWidth={2} />
                      <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-brand-500 text-white text-[10px] font-bold flex items-center justify-center">
                        {step.number}
                      </span>
                    </div>

                    {/* Vertical connector */}
                    {!isLast && (
                      <div className="w-0.5 flex-1 bg-gradient-to-b from-brand-400 to-brand-200 mt-2 mb-2"
                           style={{ minHeight: "20px" }}></div>
                    )}
                  </div>

                  {/* Right: Content */}
                  <div className="flex-1 pb-4">
                    <h3 className="font-bold text-base sm:text-lg text-slate-900 mb-1">
                      {step.title}
                    </h3>
                    <p className="text-sm text-slate-500 leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="mt-10 sm:mt-12 text-center">
          <a href="#kontakt" className="btn btn-primary btn-lg">
            Kom i gang nu
          </a>
        </div>
      </div>
    </section>
  );
}
